@for (element of elements; track identifyBreadcrumb(i, element); let first = $first; let last = $last; let i = $index) {
<ng-container class="breadcrumb">
  @if (!last) {
  <a
    class="breadcrumb__element"
    [class.breadcrumb__element--disabled]="isElementDisabled(i)"
    [routerLink]="breadcrumbClickable ? element.routerLink : []"
    [queryParams]="breadcrumbClickable ? element.queryParams : []">
    {{ element.label }}
  </a>
  <span class="breadcrumb__delimiter">/</span>
  } @else {
  <a
    class="breadcrumb__element breadcrumb__element--home"
    [class.breadcrumb__element--disabled]="isElementDisabled(i)"
    [routerLink]="breadcrumbClickable ? element.routerLink : []"
    [queryParams]="breadcrumbClickable ? element.queryParams : []">
    <mat-icon>home</mat-icon>
  </a>
  }
</ng-container>
}
